export default "__VITE_ASSET__BzUtExsa__"